import moment from "moment";
import queryString from "query-string";
import React, { Component } from "react";
import Calendar from "react-calendar";
import { connect } from "react-redux";
import {
  fetchCalendarDate,
  fetchRangeDate,
  getFootStatus,
  getMinuteWorn
} from "../../action/patientAction";
import { celToFahrenheit, celToFahrenheitDelta } from "../../action/chartAction";
import "./calendar.css";
import _ from "lodash";
import { QuestionCircleFilled } from "@ant-design/icons";
import { Popover } from "antd";

class UserStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      images: [],
      index: 0,
      date: new Date(),
      userId: "",
      id: ""
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.doctorDetails.userId && this.props.doctorDetails.userId !== prevProps.doctorDetails.userId) {
      const { getMinuteWorn } = this.props;
      const allParams = window.location.href.split("?")[1].includes("/")
        ? window.location.href.split("?")[1].split("/")[1]
        : window.location.href.split("?")[1];
      let params = queryString.parse(allParams);
      const id = params.id.replace(" ", "+");
      const userId = params.userId;
      this.setState({ userId, id });
      const StartDate = moment(moment().format("YYYY-MM-01"))
        .add(-6, "days")
        .format("YYYY-MM-DD");
      const EndDate = moment()
        .add(1, "days")
        .format("YYYY-MM-DD");
      getMinuteWorn(id, userId, StartDate, EndDate);
    }
  }

  turnChange = ({ activeStartDate, view }) => {
    const { getMinuteWorn } = this.props;
    let StartDate = moment(activeStartDate)
      .add(-6, "days")
      .format("YYYY-MM-DD");
    let EndDate = moment(activeStartDate)
      .add(35, "days")
      .format("YYYY-MM-DD");
    getMinuteWorn(this.state.id, this.state.userId, StartDate, EndDate);
  };
  onChange = date => {
    const { fetchCalendarDate, fetchRangeDate } = this.props;
    this.setState({ date: date });
    const { getFootStatus } = this.props;
    let starttime = moment(date).format("YYYY-MM-DD");
    const endtime = moment(date).format("YYYY-MM-DD");
    getFootStatus(this.state.id, this.state.userId, starttime, endtime);
    fetchCalendarDate(date);
    fetchRangeDate(date);
  };

  calendarClassName = patientWorn => ({ date, view }) => {
    let getDate = moment(date).format("YYYY-MM-DD");
    const dispensedDay = this.props.doctorDetails.dispensedDay
      ? moment(this.props.doctorDetails.dispensedDay).format("YYYY-MM-DD")
      : moment(this.props.doctorDetails.createdAt).format("YYYY-MM-DD");
    if (getDate < dispensedDay) {
      return "";
    }
    const isCurrentMonth = new Date().getMonth() === date.getMonth();
    for (var k = 0; k < patientWorn.length; k++) {
      var item = patientWorn[k];
      if (item.date > getDate) {
        return;
      }
      if (item.date === getDate && item.minuteWorn >= 30) {
        return isCurrentMonth ? "timeMore" : "timeMoreLast";
      }
    }
  };

  formatTemp(temp) {
    if (temp == null) {
      return 'N/A'
    }
    if (this.props.tempUnit === 'Celsius') {
      return temp.toFixed(1) + '℃'
    } else {
      return celToFahrenheit(temp) + '℉'
    }
  }

  formatTempDelta(temp) {
    if (temp == null) {
      return 'N/A'
    }
    if (this.props.tempUnit === 'Celsius') {
      return temp.toFixed(1) + '℃'
    } else {
      return celToFahrenheitDelta(temp) + '℉'
    }
  }

  renderSummaryHeader() {
    const KeyList = [
      {
        term: 'Avg Delta:',
        exp: 'The difference between the left and right foot’s average temperature. '
      },
      {
        term: 'Avg Delta = Left Avg Foot Temp - Right Avg Foot Temp',
        subExp: [
          <div>A positive Avg Delta means the Left Avg Foot Temp is higher than the right.<br/>(ex. Avg Delta = 2.5℉)</div>,
          <div>A negative Avg Delta means the Right Avg Foot Temp is higher than the left.<br/>(ex. Avg Delta = -2.5℉)</div>
        ]
      },
      {
        term: 'Avg 7-Day Delta: ',
        exp: 'The average Delta from the past 7 days, based on the selected date.'
      },
      {
        term: 'Up Arrow: ',
        exp: 'Indicates an increase compared to the previous measurement.',
        subExp: [
          'Example: Avg 7-Day Delta: 81℉ ↑ ',
          'The average Delta from the past 7 days is 81℉. The Avg 7-Day Delta has increased in comparison to the Avg 7-Day Delta range prior. The 7-Day range will depend on the date selected.'
        ]
      },
      {
        term: 'Down Arrow: ',
        exp: 'Indicates a decrease compared to the previous measurement.',
        subExp: [
          'Example: Avg Left Foot Temp: 81℉ ↓ ',
          'The Avg Left Foot Temp is 81℉. The Avg Left Foot Temp has decreased from the previous date.'
        ]
      }
    ]
    return (
      <div className="title">
        PATIENT SUMMARY
        <Popover
          placement="left"
          content={(
            <div style={{maxWidth: 600}}>
              <p style={{margin: 10, fontSize: 16}}><b>Patient Summary Key</b></p>
              <div style={{padding: 10, backgroundColor: '#f3f3f5'}}>
                {KeyList.map((item, i) => (
                  <div style={{marginTop: i === 0 ? 10 : 36}} key={item.term}>
                    <div><b>{item.term}</b></div>
                    {item.exp && (<p>{item.exp}</p>)}
                    {item.subExp ? (
                      <ul style={{marginLeft: 20, padding: 0}}>
                        {item.subExp.map((exp, index) => (
                          <li key={index}>{exp}</li>
                        ))}
                      </ul>
                    ) : null}
                  </div>
                ))}
              </div>
            </div>
          )}
        >
          <QuestionCircleFilled style={{fontSize: 20, float: 'right', margin: 4}} />
        </Popover>
      </div>
    )
  }

  renderSummary() {
    if (moment(this.props.changeRangeDate).isSameOrAfter(moment(), 'date')) {
      return (<p style={{padding: '20px 10px'}}>Patient Summary is calculated at the end of day when all patient data is uploaded.</p>)
    }
    if (_.isEmpty(this.props.footOverview)) {
      return (
        <div style={{ textAlign: 'left', padding: 10, boxSizing: 'border-box', display: 'flex', justifyContent: 'space-around' }}>
          <div>
            <p>Time Worn: -</p>
            <p>Total Steps: -</p>
            <p>Avg Delta: -</p>
            <p>Avg 7-Day Delta: -</p>
          </div>
          <div>
            <p>Avg Left Foot Temp: -</p>
            <p>Avg Right Foot Temp: -</p>
            <p>Last 7-Day Avg Left Foot Temp: -</p>
            <p>Last 7-Day Avg Right Foot Temp: -</p>
          </div>
        </div>
      )
    }

    const { leftAvg, rightAvg, leftPrevAvg, rightPrevAvg, leftAvg7, rightAvg7, leftPrevAvg7, rightPrevAvg7 } = this.props.footOverview

    let leftChange = '', rightChange = '', leftChange7 = '', rightChange7 = '';
    if (leftAvg && leftPrevAvg) {
      const delta = leftAvg - leftPrevAvg
      if (delta != 0) {
        leftChange = delta > 0 ? '↑' : '↓'
      }
    }
    if (rightAvg && rightPrevAvg) {
      const delta = rightAvg - rightPrevAvg
      if (delta != 0) {
        rightChange = delta > 0 ? '↑' : '↓'
      }
    }

    if (leftAvg7 && leftPrevAvg7) {
      const delta = leftAvg7 - leftPrevAvg7
      if (delta != 0) {
        leftChange7 = delta > 0 ? '↑' : '↓'
      }
    }
    if (rightAvg7 && rightPrevAvg7) {
      const delta = rightAvg7 - rightPrevAvg7
      if (delta != 0) {
        rightChange7 = delta > 0 ? '↑' : '↓'
      }
    }

    // daily delta
    let dailyDelta, day7Delta, dailyChange = '', day7Change = '';
    if (leftAvg && rightAvg) {
      dailyDelta = leftAvg - rightAvg
    }
    if (leftPrevAvg && rightPrevAvg) {
      const preDelta = leftPrevAvg - rightPrevAvg
      if (dailyDelta) {
        if (preDelta != dailyDelta) {
          dailyChange = Math.abs(dailyDelta) - Math.abs(preDelta) > 0 ? '↑' : '↓'
        }
      }
    }
    // weekly delta
    if (leftAvg7 && rightAvg7) {
      day7Delta = leftAvg7 - rightAvg7
    }
    if (leftPrevAvg7 && rightPrevAvg7) {
      const preDelta = leftPrevAvg7 - rightPrevAvg
      if (day7Delta) {
        if (preDelta != day7Delta) {
          day7Change = Math.abs(day7Delta) - Math.abs(preDelta) > 0 ? '↑' : '↓'
        }
      }
    }

    return (
      <div style={{ textAlign: 'left', padding: 10, boxSizing: 'border-box', display: 'flex', justifyContent: 'space-around' }}>
        <div>
          <p>Time Worn: {this.props.footOverview.minuteWorn || 'N/A'} mins</p>
          <p>Total Steps: {this.props.footOverview.steps || 'N/A'}</p>
          <p>Avg Delta: {this.formatTempDelta(dailyDelta)} {dailyChange}</p>
          <p>Avg 7-Day Delta: {this.formatTempDelta(day7Delta)} {day7Change}</p>
        </div>
        <div>
          <p>Avg Left Foot Temp: {this.formatTemp(leftAvg)} {leftChange}</p>
          <p>Avg Right Foot Temp: {this.formatTemp(rightAvg)} {rightChange}</p>
          <p>Last 7-Day Avg Left Foot Temp: {this.formatTemp(leftAvg7)} {leftChange7}</p>
          <p>Last 7-Day Avg Right Foot Temp: {this.formatTemp(rightAvg7)} {rightChange7}</p>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div
        className="calendar_userbox2"
        style={{
          width: this.props.Developer
            ? "55%"
            : this.props.staff
            ? "100%"
            : null
        }}
      >
        <Calendar
          onChange={this.onChange}
          value={this.props.changeRangeDate}
          tileClassName={this.calendarClassName(this.props.patientWorn)}
          // tileContent={
          //   <div style={{ fontSize: 30, color: "white", marginTop: -15 }}>
          //     .
          //   </div>
          // }
          minDetail="month"
          locale="en"
          onActiveDateChange={this.turnChange}
          style={{ height: "340px" }}
        />
        <div>
          {this.renderSummaryHeader()}
          {this.renderSummary()}
        </div>
      </div>
    );
  }
}
const mapStateToProp = state => ({
  doctorDetails: state.patientsListStore.doctorDetails,
  medicalStatus: state.patientsListStore.medicalStatus,
  patientWorn: state.patientsListStore.patientWorn,
  changeRangeDate: state.patientsListStore.changeRangeDate,
  footOverview: state.patientsListStore.footOverview,
  tempUnit: state.patientsListStore.tempUnit,
});

const mapDispatchToProp = dispatch => ({
  fetchCalendarDate: changeFootDate =>
    dispatch(fetchCalendarDate(changeFootDate)),
  fetchRangeDate: changeRangeDate => dispatch(fetchRangeDate(changeRangeDate)),
  getFootStatus: (id, userId, start, end) =>
    dispatch(getFootStatus(id, userId, start, end)),
  getMinuteWorn: (id, userId, startDate, endDate) =>
    dispatch(getMinuteWorn(id, userId, startDate, endDate))
});
export default connect(mapStateToProp, mapDispatchToProp)(UserStatus);
